module.exports = __webpack_public_path__ + "static/media/FlatBallastedImg1.3994e3b9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/FlatBallastedImg1.jpg
// module id = 1179
// module chunks = 0